<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <h3>Historia oblewanego produktu: {{ coatingProductName }}</h3>


      <b-row>
        <b-col md="2">Data</b-col>
        <b-col md="2">Osoba</b-col>
        <b-col md="8">Akcja</b-col>
      </b-row>
      <b-row class="pt-2 pb-2 border-bottom" v-for="row in historicRows" :key="row.id">
        <b-col md="2">{{ row.date | moment("DD-MM-YYYY HH:mm") }}</b-col>
        <b-col md="2">{{ row.userName }}</b-col>
        <b-col md="8" style="white-space: pre-line;">{{ row.text }}</b-col>
      </b-row>
    </div>

    <div class="row">
      <div class="col align-self-end div-form-buttons-area">
        <button type="button" class="btn-warning btn" @click="$router.go(-1)">
          Powrót
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../Common/Loading";
import axios from "axios";
import urlConfig from "../../mixins/url";
import toastr from "../../mixins/toastr";

export default {
  components: { Loading },
  mixins: [urlConfig, toastr],
  name: "CoatingProductHistory",
  computed: {},
  mounted() {
    this.getData();
  },
  data() {
    return {
      isLoaded: false,
      historicRows: [],
      coatingProductName: "",
    };
  },
  methods: {
    getData() {
      var that = this;
      var couvertureHistoryUrl =
        this.url.serverUrl +
        this.url.CoatingProduct.GetHistoryForCoatingProduct +
        this.$route.params.coatingProductInstanceId;

      axios
        .get(couvertureHistoryUrl)
        .then((result) => {
          that.historicRows = result.data.historicRows;
          that.coatingProductName = result.data.coatingProductName
          that.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(err);
        });
    },
  },
};
</script>